import { Injectable, inject } from '@angular/core';
import { CustomerContactGateway } from '../gateway/customer-contact.gateway';
import { Observable } from 'rxjs';
import { ContactFormDetails, CustomerContactFormDTO } from '@boels/models';

@Injectable({
  providedIn: 'any',
})
export class CustomerContactFacade {
  private customerContactGateway = inject(CustomerContactGateway);

  submitForm(formData: CustomerContactFormDTO): Observable<any> {
    return this.customerContactGateway.submitForm(formData);
  }

  loadDetails(): Observable<ContactFormDetails> {
    return this.customerContactGateway.loadDetails();
  }
}
